import { defineComponent } from "vue";

export default defineComponent({
  name: "Studies",
  props: {},
  components: {}
  // setup(props) {},
});
